<style scoped>
    @import url("../../styles/mv/recentMv.scss");
</style>

<template>
    <div class="box_recentMv">

        <!-- Se estiver travando a entrada, colocar um loading com flag condicionado a 1a req rcv -->

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-weather-partly-snowy</v-icon>
            <span class="ml-2">Estação meteorológica | Serra da Gardunha</span>
        </div>

        <div class="painelGeral">
            <ImgDevice2 />

            <ExibText :t="'Bateria'" :unid="'%'" :iconEl="'mdi-battery-high'" :payload="payload_st_g_recent" :r="r2" :name_key="'battery'" />
            <ExibText :t="'Umidade ar'" :unid="'%'" :iconEl="'mdi-water-percent'" :payload="payload_st_g_recent" :r="r2" :name_key="'humidity'" />
            <ExibText :t="'Temperatura ar'" :unid="'°C'" :iconEl="'mdi-thermometer-lines'" :payload="payload_st_g_recent" :r="r2" :name_key="'temperature'" />
            <ExibText :t="'Pressão'" :unid="'hPa'" :iconEl="'mdi-altimeter'" :payload="payload_st_g_recent" :r="r2" :name_key="'pressure'" />
            <ExibText :t="'Direção do vento'" :unid="'°'" :iconEl="'mdi-axis-arrow'" :payload="payload_st_g_recent" :r="r2" :name_key="'wind_direction'" />
            <ExibText :t="'Velocidade do vento'" :unid="'m/s'" :iconEl="'mdi-weather-windy'" :payload="payload_st_g_recent" :r="r2" :name_key="'wind_speed'" />

        </div>

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-chart-line</v-icon>
            <span class="ml-2">Sensor solo | Serra da Gardunha</span>
        </div>

        <div class="painelGeral">
            <ExibText :t="'Condutividade elétrica'" :unid="'uS/cm'" :iconEl="'mdi-lightning-bolt'" :payload="payload_s_g_recent" :r="r2" :name_key="'conductivity'" />
            <ExibText :t="'Umidade solo'" :unid="'%'" :iconEl="'mdi-water-percent'" :payload="payload_s_g_recent" :r="r2" :name_key="'humidity'" />
            <ExibText :t="'Temperatura solo'" :unid="'°C'" :iconEl="'mdi-thermometer-lines'" :payload="payload_s_g_recent" :r="r2" :name_key="'temperature'" />
        </div>

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-weather-partly-snowy</v-icon>
            <span class="ml-2">Estação meteorológica | Quinta Experimental Fundão</span>
        </div>

        <div class="painelGeral">
            <ImgDevice />

            <ExibText :t="'Bateria'" :unid="'%'" :iconEl="'mdi-battery-high'" :payload="payload_st_q_recent" :r="r2" :name_key="'battery'" />
            <ExibText :t="'Umidade ar'" :unid="'%'" :iconEl="'mdi-water-percent'" :payload="payload_st_q_recent" :r="r2" :name_key="'humidity'" />
            <ExibText :t="'Temperatura ar'" :unid="'°C'" :iconEl="'mdi-thermometer-lines'" :payload="payload_st_q_recent" :r="r2" :name_key="'temperature'" />
            <ExibText :t="'Pressão'" :unid="'hPa'" :iconEl="'mdi-altimeter'" :payload="payload_st_q_recent" :r="r2" :name_key="'pressure'" />
            <ExibText :t="'Direção do vento'" :unid="'°'" :iconEl="'mdi-axis-arrow'" :payload="payload_st_q_recent" :r="r2" :name_key="'wind_direction'" />
            <ExibText :t="'Velocidade do vento'" :unid="'m/s'" :iconEl="'mdi-weather-windy'" :payload="payload_st_q_recent" :r="r2" :name_key="'wind_speed'" />
        </div>

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-chart-line</v-icon>
            <span class="ml-2">Sensor solo | Quinta Experimental Fundão</span>
        </div>

        <div class="painelGeral">
            <ExibText :t="'Condutividade elétrica'" :unid="'uS/cm'" :iconEl="'mdi-lightning-bolt'" :payload="payload_s_q_recent" :r="r2" :name_key="'conductivity'" />
            <ExibText :t="'Umidade solo'" :unid="'%'" :iconEl="'mdi-water-percent'" :payload="payload_s_q_recent" :r="r2" :name_key="'humidity'" />
            <ExibText :t="'Temperatura solo'" :unid="'°C'" :iconEl="'mdi-thermometer-lines'" :payload="payload_s_q_recent" :r="r2" :name_key="'temperature'" />
        </div>

    </div>
</template>

<script>
//import GraficoMv from './GraficoMv'
import ImgDevice from './ImgDevice'
import ImgDevice2 from './ImgDevice2'
import ExibText from './ExibText'

//import Img_st_g from '../../assets/capa-up-t1.png'

export default {

    components:{ImgDevice,ImgDevice2,ExibText}, // GraficoMv,

    data() {
        return {
            //
            r:'/readingdevice',
            r2:'/lastreading',

            //img_st_g:'../../assets/capa-up-t1.png',

            payload_st_g_recent:{"cliente":"orange1","marcador":"stationGardunha"}, // rcv 1 el geral.
            payload_s_g_recent:{"cliente":"orange1","marcador":"sensorGardunha"},

            payload_st_q_recent:{"cliente":"orange1","marcador":"stationQuintaExp"},
            payload_s_q_recent:{"cliente":"orange1","marcador":"sensorQuintaExp"},
        }
    },

    methods:{
        //
    },

    created() {
        window.scrollTo(0,0)

        //this.img1 = this.Img_st_g
        //console.log('this.Img_st_g: ',this.Img_st_g)
    }
}
</script>